export default "__VITE_ASSET__C1rEVh5V__"